export const CHAT_CONFIG = {
  MAX_MESSAGE_LENGTH: 4000,
  TYPING_DELAY: 1000,
  SCROLL_DELAY: 100,
  DEBOUNCE_DELAY: 300,
  RETRY_DELAY: 2000,
  MAX_RETRIES: 3,
} as const;

export const API_CONFIG = {
  TIMEOUT: 300000,
} as const;

const getApiBaseUrl = (): string => {
  const envUrl = __API_BASE_URL__;
  
  if (import.meta.env.DEV) {
    return '/';
  }
  
  if (!envUrl) {
    console.warn('API_BASE_URL not found in environment variables, using /api as fallback');
    return '/api';
  }
  
  return envUrl.replace(/\/$/, '');
};

export const API_BASE_URL = getApiBaseUrl();
export const DEFAULT_MODEL = __DEFAULT_MODEL__;
export const DEFAULT_THREAD_ID = '1';
export const ENABLE_FILE_UPLOAD = __ENABLE_FILE_UPLOAD__;


